module.exports = __webpack_public_path__ + "static/media/2022_23_gesamt.9d5b9743.jpg";